import inventoryAPI from "@/api/inventories";

const getInventories = async (context, data) => {
  const response = await inventoryAPI.getInventories(
    data.token,
    data.page,
    data.assign,
    data.code,
    data.no_assign,
    data.email,
    data.type
  );

  if (response.status) context.commit("setInventories", response.data);
};

const getInventoriesWithoutPagination = async (context, data) => {
  const response = await inventoryAPI.getInventoriesWithoutPagination(
    data.token,
    data.assign,
    data.no_assign,
    data.type,
    data.vet
  );

  if (response.status)
    context.commit("setInventoriesWithoutPagination", response.data);
};

let actions = {
  getInventories,
  getInventoriesWithoutPagination
};

export default actions;
